import { render, staticRenderFns } from "./OurLeaders.vue?vue&type=template&id=fcd1734c&"
import script from "./OurLeaders.vue?vue&type=script&lang=js&"
export * from "./OurLeaders.vue?vue&type=script&lang=js&"
import style0 from "./OurLeaders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports